import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./ExpenseDatePicker.css";

const pad = (n) => String(n).padStart(2, "0");

// 'YYYY-MM-DD' -> a Date at LOCAL midnight (never new Date("YYYY-MM-DD"), which is
// UTC midnight and shows the previous day west of UTC).
export const ymdToDate = (ymd) => {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(ymd || ""));
  return m ? new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3])) : null;
};

export const dateToYmd = (date) =>
  date instanceof Date && !Number.isNaN(date.getTime())
    ? `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`
    : "";

// Date input that always SHOWS dd-Mon-yyyy (01-Sep-2026) regardless of the
// browser/OS region - the native <input type="date"> follows the region, so it
// showed mm/dd/yyyy on a US-region computer next to a dd-Mon-yyyy grid. Takes and
// emits 'YYYY-MM-DD' strings ('' when empty), the same value the API uses.
//
// The popper renders through a portal above the SlidePanel (see the css file):
// the panel is transformed and scrolls, which would otherwise clip the calendar.
function ExpenseDatePicker({ id, value, onChange, min, max, isClearable = false, disabled = false, invalid = false, compact = false }) {
  return (
    <DatePicker
      id={id}
      selected={ymdToDate(value)}
      onChange={(date) => onChange(dateToYmd(date))}
      dateFormat="dd-MMM-yyyy"
      placeholderText="dd-mmm-yyyy"
      minDate={ymdToDate(min) || undefined}
      maxDate={ymdToDate(max) || undefined}
      isClearable={isClearable}
      disabled={disabled}
      autoComplete="off"
      className={`form-control expense-datepicker-input${compact ? " is-compact" : ""}${invalid ? " is-invalid" : ""}`}
      portalId="expense-datepicker-portal"
      popperClassName="expense-datepicker-popper"
      popperProps={{ strategy: "fixed" }}
    />
  );
}

export default ExpenseDatePicker;
